var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.840782 5.93177H10.0679C10.2464 5.93177 10.401 5.86659 10.5314 5.73612C10.6617 5.60569 10.7271 5.45124 10.7271 5.27273C10.7271 5.09422 10.6617 4.93984 10.5314 4.80923L5.91776 0.195643C5.78741 0.0653586 5.63299 0 5.45437 0C5.27576 0 5.12134 0.0653586 4.99088 0.195643L0.377284 4.80923C0.246819 4.9397 0.181641 5.09422 0.181641 5.27273C0.181641 5.45121 0.246819 5.60569 0.377284 5.73612C0.507893 5.86659 0.662308 5.93177 0.840782 5.93177Z",
    fill: "#D3D6E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortup);
export default __webpack_public_path__ + "static/media/sortup.1953b21f.svg";
export { ForwardRef as ReactComponent };